// extracted by mini-css-extract-plugin
module.exports = {"root":"MerchListItem_root__8ce9n","infoWrapper":"MerchListItem_infoWrapper__rH5oc"};